import { useAppSelector, useTranslate } from '@common/hooks'

import StarsRow from '../StarsRow'
import classNames from './styles.module.scss'


export default function Score(): JSX.Element | null {
  const { translate, interpolate } = useTranslate()
  const ratings_avg = useAppSelector(store => store.applicationRating.data?.app.ratingAvg)
  const total = useAppSelector(store => store.applicationRating.data?.app.ratingScores.reduce((acc, curr) => acc + curr, 0))

  if(!ratings_avg) {
    return null
  }

  return (
    <div className={classNames.scoreWrapper}>
      <h3 className={classNames.score} data-test="rating-score">{ratings_avg}</h3>
      <StarsRow value={ratings_avg} className={classNames.star}/>
      <h5 className={classNames.scoreLabel} data-test="rating-total">
        {total === 1 ? translate('1 rating') : interpolate(translate('%s ratings'), [total || ''])}
      </h5>
    </div>
  )
}
